import AircraftGallerySlider from './AircraftGallerySlider';
export default AircraftGallerySlider;
